import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';
import { BodyModule, GridModule } from '@progress/kendo-angular-grid';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { SharedModule } from '../../shared/shared.module';
import { WeatherLogManageReadingsPage } from './weather-log-manage-readings';
import {
  WeatherLogAddStandaloneReadingComponent
} from './components/weather-log-add-standalone-reading/weather-log-add-standalone-reading';
import {
  WeatherLogStandaloneReadingGridComponent
} from './components/weather-log-standalone-reading-grid/weather-log-standalone-reading-grid';

@NgModule({
  declarations: [
    WeatherLogManageReadingsPage,
    WeatherLogAddStandaloneReadingComponent,
    WeatherLogStandaloneReadingGridComponent
  ],
  exports: [
    WeatherLogStandaloneReadingGridComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(WeatherLogManageReadingsPage),
    TextMaskModule,
    GridModule,
    BodyModule,
    SharedModule,
    TabStripModule,
    SharedModule,
  ],
  entryComponents: [
    WeatherLogAddStandaloneReadingComponent
  ]
})
export class WeatherLogManageRecordingsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-manage-readings/weather-log-manage-readings.module.ts